import React from "react";
import { Link } from "react-router-dom";
import { LoaderButton, ContinueLabel } from "ctia-ui";
import {
  Col,
  Tooltip,
  Jumbotron,
  Glyphicon,
  OverlayTrigger
} from "react-bootstrap";

import "containers/request/RequestTypeBlock.css";

const RequestTypeBlock = ({ request }) => {
  const btnTitle = request.locked ? "Coming soon" : <ContinueLabel />;

  return (
    <Col xs={6}>
      <Jumbotron className="jumbo-block text-center">
        <h2 className="jumbo-block-header">
          {request.title}{" "}
          {!request.locked && (
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="typeHint">{request.hint}</Tooltip>}
            >
              <Glyphicon glyph="question-sign" className="jumbo-block-icon" />
            </OverlayTrigger>
          )}
        </h2>
        <Link to={`/request/new/${request.link}`}>
          <LoaderButton
            bsSize="large"
            bsStyle="info"
            text={btnTitle}
            disabled={request.locked}
          />
        </Link>
      </Jumbotron>
    </Col>
  );
};

export default RequestTypeBlock;



// WEBPACK FOOTER //
// ./src/containers/request/RequestTypeBlock.js